// src/components/ScrollToTopButton.jsx
import { useState, useEffect } from 'react';
import '../../styles/ScrollToTopButton.css'
const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {     // ← adjust this value as you like
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        // cleanup
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    if (!isVisible) return null;

    return (
        <button
            onClick={scrollToTop}
            className="scroll-to-top-btn"
            aria-label="Scroll back to top"
        >
            ↑
        </button>
    );
};

export default ScrollToTopButton;